export const APP_CONSTS = {
  moduleName: 'epb-app',

  getters: {
    featuresTree: 'featuresTree',
    fullscreen: 'fullscreen',
    alreadyLoggedInOnce: 'alreadyLoggedInOnce',
    menuCollapsed: 'menuCollapsed',
    filtersHidden: 'filtersHidden',
    playedAnimations: 'playedAnimations',
    loading: 'loading',
  },
  actions: {
    setFullscreen: 'setFullscreen',
    setAlreadyLoggedInOnce: 'setAlreadyLoggedInOnce',
    setMenuCollapsed: 'setMenuCollapsed',
    setFiltersHidden: 'setFiltersHidden',
    addPlayedAnimation: 'addPlayedAnimation',
    setLoading: 'setLoading',
  },
  mutations: {
    setFullscreen: 'setFullscreen',
    setAlreadyLoggedInOnce: 'setAlreadyLoggedInOnce',
    setMenuCollapsed: 'setMenuCollapsed',
    setFiltersHidden: 'setFiltersHidden',
    setLoading: 'setLoading',
    addPlayedAnimation: 'addPlayedAnimation',
  },
  storage: {
    alreadyLoggedInOnce: 'already-logged-in-once',
    menuCollapsed: 'menu-collapsed',
    feedback: 'feedback',
  },
}
